import React, { useEffect, useRef } from 'react';
import hotkeys from 'hotkeys-js';
import { setupHighlighter } from './utils/highlight';
import { getElementCodeInfo, gotoEditor, getElementInspect, } from './utils/inspect';
import Overlay from './Overlay';
export const defaultHotKeys = ['control', 'shift', 'command', 'c'];
export const Inspector = (props) => {
    const { keys, onHoverElement, onClickElement, disableLaunchEditor, children, } = props;
    // hotkeys-js params need string
    const hotkey = (keys !== null && keys !== void 0 ? keys : defaultHotKeys).join('+');
    /** inspector tooltip overlay */
    const overlayRef = useRef();
    const mousePointRef = useRef({ x: 0, y: 0 });
    const recordMousePoint = ({ clientX, clientY }) => {
        mousePointRef.current.x = clientX;
        mousePointRef.current.y = clientY;
    };
    const startInspect = () => {
        const overlay = new Overlay();
        overlayRef.current = overlay;
        const stopCallback = setupHighlighter({
            onPointerOver: handleHoverElement,
            onClick: handleClickElement,
        });
        overlay.setRemoveCallback(stopCallback);
        // inspect element immediately at mouse point
        const initPoint = mousePointRef.current;
        const initElement = document.elementFromPoint(initPoint.x, initPoint.y);
        if (initElement)
            handleHoverElement(initElement);
    };
    const stopInspect = () => {
        var _a;
        (_a = overlayRef.current) === null || _a === void 0 ? void 0 : _a.remove();
        overlayRef.current = undefined;
    };
    const handleHoverElement = (element) => {
        var _a;
        const overlay = overlayRef.current;
        const codeInfo = getElementCodeInfo(element);
        const relativePath = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.relativePath;
        const absolutePath = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.absolutePath;
        const { fiber, name, title } = getElementInspect(element);
        (_a = overlay === null || overlay === void 0 ? void 0 : overlay.inspect) === null || _a === void 0 ? void 0 : _a.call(overlay, [element], title, relativePath !== null && relativePath !== void 0 ? relativePath : absolutePath);
        onHoverElement === null || onHoverElement === void 0 ? void 0 : onHoverElement({
            element,
            fiber,
            codeInfo,
            name,
        });
    };
    const handleClickElement = (element) => {
        stopInspect();
        const codeInfo = getElementCodeInfo(element);
        const { fiber, name } = getElementInspect(element);
        if (!disableLaunchEditor)
            gotoEditor(codeInfo);
        onClickElement === null || onClickElement === void 0 ? void 0 : onClickElement({
            element,
            fiber,
            codeInfo,
            name,
        });
    };
    useEffect(() => {
        document.addEventListener('mousemove', recordMousePoint, true);
        return () => {
            document.removeEventListener('mousemove', recordMousePoint, true);
        };
    }, []);
    useEffect(() => {
        const handleHotKeys = (event, handler) => {
            if (handler.key === hotkey) {
                overlayRef.current
                    ? stopInspect()
                    : startInspect();
            }
            else if (handler.key === 'esc' && overlayRef.current) {
                stopInspect();
            }
        };
        // https://github.com/jaywcjlove/hotkeys
        hotkeys(`${hotkey}, esc`, handleHotKeys);
        /**
         * @deprecated only for debug, will remove in next version
         */
        window.__REACT_DEV_INSPECTOR_TOGGLE__ = () => overlayRef.current
            ? stopInspect()
            : startInspect();
        return () => {
            hotkeys.unbind(`${hotkey}, esc`, handleHotKeys);
            delete window.__REACT_DEV_INSPECTOR_TOGGLE__;
        };
    }, [hotkey]);
    return (React.createElement(React.Fragment, null, children !== null && children !== void 0 ? children : null));
};
